import React from 'react';
import { cn } from "@/lib/utils"
// @ts-ignore
import Logo from "../../assets/images/logo.png";
import {useNavigate} from "react-router-dom"; // Import the image

interface SidebarItemProps {
    label: string
    id: string
    isActive?: boolean
    onClick?: (id: string) => void
}

function SidebarItem({ label, id, isActive, onClick }: SidebarItemProps) {
    return (
        <button
            className={cn(
                "w-full text-left px-4 py-3 text-base font-medium transition-colors",
                isActive ? "bg-gray-100 text-gray-900" : "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
            )}
            onClick={() => onClick?.(id)}
        >
            {label}
        </button>
    )
}

interface SidebarProps {
    activeMenuItem: string
}

export function Sidebar({ activeMenuItem }: SidebarProps) {
    const navigate = useNavigate()

    return (
        <div className="w-64 border-r bg-gray-50">
            <div className="p-4">
                <a href="/" className="flex items-center">
                    <img src={Logo} alt="Cloudhooks" className="h-8" />
                </a>
            </div>
            <nav className="mt-6">
                <SidebarItem
                    label="Trials"
                    id="active-trials"
                    isActive={activeMenuItem === "active-trials"}
                    onClick={() => navigate('/trials')}
                />
                <SidebarItem
                    label="Expired trials"
                    id="expired-trials"
                    isActive={activeMenuItem === "expired-trials"}
                    onClick={() => navigate('/expired-trials')}
                />
            </nav>
        </div>
    )
}
